import { useEffect } from 'react';

let locks = 0;
let previousOverflow = '';
export const useBodyScrollLock = (active) => {
  useEffect(() => {
    if (!active) return undefined;
    if (locks === 0) previousOverflow = document.body.style.overflow;
    locks += 1;
    document.body.style.overflow = 'hidden';
    return () => {
      locks -= 1;
      if (locks === 0) document.body.style.overflow = previousOverflow;
    };
  }, [active]);
};